import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './category-browse.css'

const CategoryBrowse = (props) => {
  return (
    <div className="category-browse-container1">
      <Helmet>
        <title>Category-Browse - BidWally</title>
        <meta
          property="og:title"
          content="Category-Browse - BidWally"
        />
        <link
          rel="canonical"
          href="https://bidwally.com/category-browse"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-browse">
        <div className="hero-browse-media">
          <img
            src="https://images.pexels.com/photos/2218136/pexels-photo-2218136.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            alt="Modern city skyline at sunset"
            className="hero-browse-bg"
          />
          <div className="hero-browse-overlay"></div>
        </div>
        <div className="hero-browse-content">
          <div className="hero-browse-text-block">
            <h1 className="hero-title">Explore Local Crypto Listings</h1>
            <p className="hero-subtitle">
              The non-custodial marketplace for your community. Browse vehicles,
              electronics, and services with real-time crypto pricing and local
              discovery.
            </p>
            <div className="hero-browse-quick-filters">
              <div className="quick-filter-item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <span>Near You: San Francisco</span>
              </div>
              <div className="quick-filter-item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042l-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893l-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042l.348-1.97M7.48 20.364l3.126-17.727"></path>
                </svg>
                <span>Price: Any Range</span>
              </div>
            </div>
            <div className="hero-browse-actions">
              <button className="btn btn-primary btn-lg">
                Browse All Categories
              </button>
              <button className="btn btn-lg btn-outline">How it Works</button>
            </div>
          </div>
        </div>
      </section>
      <section className="search-panel">
        <div className="search-panel-container">
          <div className="search-panel-left">
            <div className="search-input-wrapper">
              <input
                type="text"
                placeholder="Search vehicles, electronics, jobs..."
                className="search-main-input"
              />
              <button className="search-submit-btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="m21 21-4.3-4.3"></path>
                </svg>
              </button>
            </div>
            <div className="search-sub-filters">
              <button className="filter-chip active">All</button>
              <button className="filter-chip">Vehicles</button>
              <button className="filter-chip">Electronics</button>
              <button className="filter-chip">Housing</button>
              <button className="filter-chip">Services</button>
            </div>
          </div>
          <div className="search-panel-right">
            <div className="advanced-filters-grid">
              <div className="filter-group">
                <label className="section-content">Price Toggle</label>
                <div className="toggle-switch-container">
                  <span className="toggle-label">Crypto</span>
                  <div className="category-browse-toggle-switch"></div>
                  <span className="toggle-label">Fiat</span>
                </div>
              </div>
              <div className="filter-group">
                <label className="section-content">Verification</label>
                <select className="category-browse-filter-select">
                  <option>All Sellers</option>
                  <option>Verified Only</option>
                  <option>High Reputation</option>
                </select>
              </div>
              <div className="filter-group">
                <button className="map-trigger btn btn-secondary btn-sm">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0zm.894.211v15M9 3.236v15"></path>
                  </svg>
                  <span>
                    {' '}
                    Show Map
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="listing-grid">
        <div className="listing-grid-header">
          <h2 className="section-title">Latest Listings</h2>
        </div>
        <div className="listing-grid-container">
          <article className="category-browse-listing-card">
            <div className="listing-card-media">
              <img
                src="https://images.pexels.com/photos/9966011/pexels-photo-9966011.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Modern Car Interface"
                className="listing-img"
              />
              <span className="listing-tag">Vehicles</span>
              <button className="listing-fav-btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676a.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"></path>
                </svg>
              </button>
            </div>
            <div className="listing-card-body">
              <div className="listing-seller-info">
                <div className="seller-badge">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12 2 2 4-4"></path>
                  </svg>
                  <span>Verified</span>
                </div>
                <span className="rep-score">4.9 ★</span>
              </div>
              <h3 className="section-subtitle">2024 Electric Sedan Pro</h3>
              <div className="listing-price-block">
                <span className="category-browse-crypto-price crypto-price">
                  0.85 BTC
                </span>
                <span className="category-browse-fiat-ref">≈ $52,400</span>
              </div>
              <div className="listing-location">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <span>San Francisco, CA</span>
              </div>
              <div className="listing-actions">
                <button className="btn btn-primary btn-sm">View Details</button>
                <button className="btn btn-outline btn-sm">Contact</button>
              </div>
            </div>
          </article>
          <article className="category-browse-listing-card">
            <div className="listing-card-media">
              <img
                src="https://images.pexels.com/photos/4590387/pexels-photo-4590387.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Workstation"
                className="listing-img"
              />
              <span className="listing-tag">Electronics</span>
              <button className="listing-fav-btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676a.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"></path>
                </svg>
              </button>
            </div>
            <div className="listing-card-body">
              <div className="listing-seller-info">
                <div className="seller-badge">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12 2 2 4-4"></path>
                  </svg>
                  <span>Verified</span>
                </div>
                <span className="rep-score">5.0 ★</span>
              </div>
              <h3 className="section-subtitle">Custom AI Workstation</h3>
              <div className="listing-price-block">
                <span className="category-browse-crypto-price crypto-price">
                  1.2 ETH
                </span>
                <span className="category-browse-fiat-ref">≈ $3,100</span>
              </div>
              <div className="listing-location">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <span>Austin, TX</span>
              </div>
              <div className="listing-actions">
                <button className="btn btn-primary btn-sm">View Details</button>
                <button className="btn btn-outline btn-sm">Contact</button>
              </div>
            </div>
          </article>
          <article className="category-browse-listing-card">
            <div className="listing-card-media">
              <img
                src="https://images.pexels.com/photos/3201758/pexels-photo-3201758.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Apartment"
                className="listing-img"
              />
              <span className="listing-tag">Housing</span>
              <button className="listing-fav-btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676a.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"></path>
                </svg>
              </button>
            </div>
            <div className="listing-card-body">
              <div className="listing-seller-info">
                <div className="seller-badge">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12 2 2 4-4"></path>
                  </svg>
                  <span>Verified</span>
                </div>
                <span className="rep-score">4.8 ★</span>
              </div>
              <h3 className="section-subtitle">Loft Apartment Rental</h3>
              <div className="listing-price-block">
                <span className="category-browse-crypto-price crypto-price">
                  450 USDC / mo
                </span>
                <span className="category-browse-fiat-ref">≈ $450</span>
              </div>
              <div className="listing-location">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <span>Toronto, ON</span>
              </div>
              <div className="listing-actions">
                <button className="btn btn-primary btn-sm">View Details</button>
                <button className="btn btn-outline btn-sm">Contact</button>
              </div>
            </div>
          </article>
          <article className="category-browse-listing-card">
            <div className="listing-card-media">
              <img
                src="https://images.pexels.com/photos/16052506/pexels-photo-16052506.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Drone"
                className="listing-img"
              />
              <span className="listing-tag">Digital Goods</span>
              <button className="listing-fav-btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676a.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"></path>
                </svg>
              </button>
            </div>
            <div className="listing-card-body">
              <div className="listing-seller-info">
                <div className="seller-badge">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12 2 2 4-4"></path>
                  </svg>
                  <span>Verified</span>
                </div>
                <span className="rep-score">4.7 ★</span>
              </div>
              <h3 className="section-subtitle">4K Drone Photography Kit</h3>
              <div className="listing-price-block">
                <span className="category-browse-crypto-price crypto-price">
                  0.12 BTC
                </span>
                <span className="category-browse-fiat-ref">≈ $7,400</span>
              </div>
              <div className="listing-location">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <span>Miami, FL</span>
              </div>
              <div className="listing-actions">
                <button className="btn btn-primary btn-sm">View Details</button>
                <button className="btn btn-outline btn-sm">Contact</button>
              </div>
            </div>
          </article>
          <article className="category-browse-listing-card">
            <div className="listing-card-media">
              <img
                src="https://images.pexels.com/photos/8470773/pexels-photo-8470773.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Architect"
                className="listing-img"
              />
              <span className="listing-tag">Services</span>
              <button className="listing-fav-btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676a.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"></path>
                </svg>
              </button>
            </div>
            <div className="listing-card-body">
              <div className="listing-seller-info">
                <div className="seller-badge">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12 2 2 4-4"></path>
                  </svg>
                  <span>Verified</span>
                </div>
                <span className="rep-score">4.9 ★</span>
              </div>
              <h3 className="section-subtitle">Architectural Design</h3>
              <div className="listing-price-block">
                <span className="category-browse-crypto-price crypto-price">
                  0.5 ETH / hr
                </span>
                <span className="category-browse-fiat-ref">≈ $1,250</span>
              </div>
              <div className="listing-location">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <span>London, UK</span>
              </div>
              <div className="listing-actions">
                <button className="btn btn-primary btn-sm">View Details</button>
                <button className="btn btn-outline btn-sm">Contact</button>
              </div>
            </div>
          </article>
          <article className="category-browse-listing-card">
            <div className="listing-card-media">
              <img
                src="https://images.pexels.com/photos/8566636/pexels-photo-8566636.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Robots"
                className="listing-img"
              />
              <span className="listing-tag">Collectibles</span>
              <button className="listing-fav-btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676a.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"></path>
                </svg>
              </button>
            </div>
            <div className="listing-card-body">
              <div className="listing-seller-info">
                <div className="seller-badge">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12 2 2 4-4"></path>
                  </svg>
                  <span>Verified</span>
                </div>
                <span className="rep-score">5.0 ★</span>
              </div>
              <h3 className="section-subtitle">Vintage Robot Collection</h3>
              <div className="listing-price-block">
                <span className="category-browse-crypto-price crypto-price">
                  12,000 MATIC
                </span>
                <span className="category-browse-fiat-ref">≈ $6,800</span>
              </div>
              <div className="listing-location">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <span>Tokyo, JP</span>
              </div>
              <div className="listing-actions">
                <button className="btn btn-primary btn-sm">View Details</button>
                <button className="btn btn-outline btn-sm">Contact</button>
              </div>
            </div>
          </article>
        </div>
      </section>
      <section className="map-explore">
        <div className="map-explore-content">
          <div className="map-text-block">
            <h2 className="section-title">Local Market Hotspots</h2>
            <p className="section-content">
              Discover what&apos;s selling in your neighborhood. Our interactive
              map shows real-time clusters of listings, allowing you to find the
              best deals within walking distance.
            </p>
            <div className="map-stats">
              <div className="stat-item">
                <span className="stat-val">1,240+</span>
                <span className="category-browse-stat-label">
                  Active Listings
                </span>
              </div>
              <div className="stat-item">
                <span className="stat-val">45</span>
                <span className="category-browse-stat-label">
                  Cities Covered
                </span>
              </div>
            </div>
            <button className="btn btn-lg btn-accent">
              Open Full Map View
            </button>
          </div>
        </div>
        <div className="map-explore-visual">
          <div className="category-browse-map-placeholder">
            <img
              src="https://images.pexels.com/photos/5226497/pexels-photo-5226497.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Navigation Map Interface"
              className="map-img"
            />
            <div className="map-pins-overlay">
              <div className="category-browse-thq-map-pin-pulse-elm1 map-pin-pulse"></div>
              <div className="category-browse-thq-map-pin-pulse-elm2 map-pin-pulse"></div>
              <div className="category-browse-thq-map-pin-pulse-elm3 map-pin-pulse"></div>
            </div>
          </div>
        </div>
      </section>
      <section className="featured-showcase">
        <div className="showcase-header">
          <h2 className="section-title">Featured Opportunities</h2>
          <p className="section-subtitle">
            Premium listings from our most trusted sellers and curated
            subcategories.
          </p>
        </div>
        <div className="category-browse-showcase-grid">
          <div className="showcase-item sponsor">
            <div className="item-badge">
              <span>Featured</span>
            </div>
            <img
              src="https://images.pexels.com/photos/106787/pexels-photo-106787.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="City Property"
              className="showcase-img"
            />
            <div className="item-overlay">
              <h4 className="section-subtitle">Downtown Penthouse</h4>
              <span className="section-content">12.5 BTC</span>
            </div>
          </div>
          <div className="showcase-item">
            <img
              src="https://images.pexels.com/photos/5356281/pexels-photo-5356281.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Executive Car"
              className="showcase-img"
            />
            <div className="item-overlay">
              <h4 className="section-subtitle">
                Certified Executive Transport
              </h4>
              <span className="section-content">1.2 BTC</span>
            </div>
          </div>
          <div className="showcase-item">
            <img
              src="https://images.pexels.com/photos/20341307/pexels-photo-20341307.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Digital Tech"
              className="showcase-img"
            />
            <div className="item-overlay">
              <h4 className="section-subtitle">Smart Mobility Fleet</h4>
              <span className="section-content">50,000 USDC</span>
            </div>
          </div>
          <div className="showcase-item">
            <img
              src="https://images.pexels.com/photos/4065133/pexels-photo-4065133.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Home Office"
              className="showcase-img"
            />
            <div className="item-overlay">
              <h4 className="section-subtitle">Co-working Space Pass</h4>
              <span className="section-content">0.05 ETH</span>
            </div>
          </div>
          <div className="showcase-item">
            <img
              src="https://images.pexels.com/photos/8566631/pexels-photo-8566631.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Delivery Tech"
              className="showcase-img"
            />
            <div className="item-overlay">
              <h4 className="section-subtitle">Last-Mile Logistics Hub</h4>
              <span className="section-content">2.4 BTC</span>
            </div>
          </div>
          <div className="showcase-item sponsor">
            <div className="item-badge">
              <span>Promoted</span>
            </div>
            <img
              src="https://images.pexels.com/photos/17220962/pexels-photo-17220962.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Dash Tech"
              className="showcase-img"
            />
            <div className="item-overlay">
              <h4 className="section-subtitle">Premium Navigation Suite</h4>
              <span className="section-content">150 MATIC</span>
            </div>
          </div>
        </div>
      </section>
      <section className="trust-strip">
        <div className="trust-column">
          <div className="trust-icon-box">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
              <path d="m9 12 2 2 4-4"></path>
            </svg>
          </div>
          <h3 className="section-subtitle">Verified Sellers</h3>
          <p className="section-content">
            Every professional seller undergoes a strict multi-step verification
            process to ensure market integrity.
          </p>
        </div>
        <div className="trust-column">
          <div className="trust-icon-box">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16z"></path>
            </svg>
          </div>
          <h3 className="section-subtitle">Reputation Scores</h3>
          <p className="section-content">
            Community-driven ratings and flags help you identify reliable peers
            and avoid potential scams.
          </p>
        </div>
        <div className="trust-column">
          <div className="trust-icon-box">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"></path>
            </svg>
          </div>
          <h3 className="section-subtitle">Escrow Roadmap</h3>
          <p className="section-content">
            <span>
              We are building a non-custodial escrow system to make P2P crypto
              trading safer than ever.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <a href="#">
              <div className="btn-link">
                <span>Learn More</span>
              </div>
            </a>
          </p>
        </div>
      </section>
      <section className="market-reviews">
        <div className="reviews-container">
          <div className="reviews-intro">
            <h2 className="section-title">Community Feedback</h2>
            <div className="category-rating">
              <span className="rating-num">4.8</span>
              <div className="stars">
                <span>★★★★★</span>
              </div>
              <span className="rating-count">(2,450 Reviews)</span>
            </div>
          </div>
          <div className="reviews-grid">
            <div className="review-card">
              <div className="review-header">
                <span className="reviewer-name">Alex K.</span>
                <span className="review-stars">★★★★★</span>
              </div>
              <p className="section-content">
                &quot;Found a great deal on a workstation. The non-custodial
                payment was smooth and the seller was highly responsive.&quot;
              </p>
            </div>
            <div className="review-card">
              <div className="review-header">
                <span className="reviewer-name">Sarah M.</span>
                <span className="review-stars">★★★★☆</span>
              </div>
              <p className="section-content">
                &quot;Easy to filter by city. Met the seller in person and
                completed the transaction in USDC. Very safe experience.&quot;
              </p>
            </div>
            <div className="review-card">
              <div className="review-header">
                <span className="reviewer-name">David L.</span>
                <span className="review-stars">★★★★★</span>
              </div>
              <p className="section-content">
                &quot;Verified badges really help. I only deal with 4.5+ star
                sellers and haven&apos;t had a single issue yet.&quot;
              </p>
            </div>
            <div className="review-card">
              <div className="review-header">
                <span className="reviewer-name">Elena R.</span>
                <span className="review-stars">★★★★★</span>
              </div>
              <p className="section-content">
                &quot;The crypto/fiat toggle is a lifesaver for calculating
                real-world value on the fly. Highly recommend BidWally.&quot;
              </p>
            </div>
            <div className="review-card">
              <div className="review-header">
                <span className="reviewer-name">Marcus G.</span>
                <span className="review-stars">★★★★☆</span>
              </div>
              <p className="section-content">
                &quot;Great selection of digital goods. The escrow roadmap looks
                promising for future high-value trades.&quot;
              </p>
            </div>
            <div className="review-card">
              <div className="review-header">
                <span className="reviewer-name">Jasmine W.</span>
                <span className="review-stars">★★★★★</span>
              </div>
              <p className="section-content">
                &quot;Finally a crypto marketplace that doesn&apos;t feel like a
                casino. Professional, clean, and trustworthy UI.&quot;
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="cta-post">
        <div className="cta-post-container">
          <div className="cta-card">
            <div className="category-browse-cta-content">
              <h2 className="section-title">Ready to Sell for Crypto?</h2>
              <p className="section-content">
                Join thousands of sellers reaching a global audience. Post your
                listing in minutes and choose your preferred crypto assets for
                payment.
              </p>
              <div className="cta-benefits">
                <div className="benefit-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                  <span>No Listing Fees</span>
                </div>
                <div className="benefit-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                  <span>Verified Audience</span>
                </div>
                <div className="benefit-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                  <span>Featured Options</span>
                </div>
              </div>
              <div className="category-browse-cta-actions">
                <button className="btn btn-primary btn-xl">
                  Post a Listing Now
                </button>
                <button className="btn btn-outline btn-xl">
                  View Seller Tiers
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="category-browse-container2">
        <div className="category-browse-container3">
          <Script
            html={`<script defer data-name="category-browse-logic">
(function(){
  // Toggle switch functionality for crypto/fiat
  const toggleSwitch = document.querySelector('.toggle-switch');
  if (toggleSwitch) {
    toggleSwitch.addEventListener('click', () => {
      toggleSwitch.style.justifyContent = toggleSwitch.style.justifyContent === 'flex-end' ? 'flex-start' : 'flex-end';
      // In a real app, this would trigger a state change for all price displays
    });
  }

  // Filter chip selection
  const filterChips = document.querySelectorAll('.filter-chip');
  filterChips.forEach(chip => {
    chip.addEventListener('click', () => {
      filterChips.forEach(c => c.classList.remove('active'));
      chip.classList.add('active');
    });
  });

  // Favorite button toggle
  const favButtons = document.querySelectorAll('.listing-fav-btn');
  favButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const icon = btn.querySelector('svg');
      if (icon.getAttribute('fill') === 'currentColor') {
        icon.setAttribute('fill', 'none');
        btn.style.color = 'inherit';
      } else {
        icon.setAttribute('fill', 'currentColor');
        btn.style.color = 'var(--color-accent)';
      }
    });
  });

  // Map trigger mock action
  const mapTrigger = document.querySelector('.map-trigger');
  if (mapTrigger) {
    mapTrigger.addEventListener('click', () => {
      const mapSection = document.querySelector('.map-explore');
      if (mapSection) {
        mapSection.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default CategoryBrowse
